// Mainly used to add the Datapool name to the Jobs
import { apiRequest } from './_tools';

export function getRepositoryName(repositoryCode) {
  return apiRequest(`/api/workbench/collab/gitrepo/${repositoryCode}/name`);
}
